import { h } from "./../../utils/createElement";
import { __assign, __extends } from "tslib";
import * as React from 'react';
import { consumeTheme } from '../../utils/theme';
import Calendar from './rc-calendar/Calendar';
import { trueFn } from '../../utils/helper';
var DatePicker = (function (_super) {
    __extends(DatePicker, _super);
    function DatePicker() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.shouldDisableDate = function (value) {
            return !_this.props.shouldEnableDate(value);
        };
        _this.themedRender = function (classNames) {
            var _a = _this.props, prefixCls = _a.prefixCls, className = _a.className, style = _a.style, showFooter = _a.showFooter, value = _a.value, onChange = _a.onChange, defaultValue = _a.defaultValue, onSelect = _a.onSelect, defaultSelectedValue = _a.defaultSelectedValue, selectedValue = _a.selectedValue;
            var cls = classNames(prefixCls, className);
            var showFooterProps = showFooter ? null : {
                showToday: false,
                showOk: false,
            };
            return (h(Calendar, __assign({ className: cls, style: style, showDateInput: false, disabledDate: _this.shouldDisableDate, defaultValue: defaultValue, value: value, selectedValue: selectedValue, defaultSelectedValue: defaultSelectedValue, onSelect: onSelect, onChange: onChange }, showFooterProps)));
        };
        return _this;
    }
    DatePicker.prototype.render = function () {
        return consumeTheme(this.themedRender);
    };
    return DatePicker;
}(React.Component));
export default DatePicker;
DatePicker.defaultProps = {
    prefixCls: 'dui-datepicker',
    shouldEnableDate: trueFn,
    showFooter: true,
};
